export type AboutSkill = {
    iconId: 'code' | 'server' | 'globe' | 'database';
    title: string;
    description: string;
    technologies: string[];
};

export type AboutMock = {
    title: string;
    subtitle: string;
    summaryCard: {
        iconId: 'user';
        title: string;
        text: string;
    };
    contactCard: {
        title: string;
        email: string;
        location: string;
    };
    skills: AboutSkill[];
    quote: {
        text: string;
        subtitle: string;
    };
};

export const aboutMock: AboutMock = {
    title: 'About Me',
    subtitle: 'Full-Stack Developer specializing in modern web technologies and scalable solutions',
    summaryCard: {
        iconId: 'user',
        title: 'Summary',
        text: 'My name is Mykola, a Middle Full-Stack Developer with a strong foundation in web development since 2022. I have hands-on experience in both team collaborations and independent project leadership.',
    },
    contactCard: {
        title: 'Contact',
        email: 'teriv168@gmail.com',
        location: 'Ukraine',
    },
    skills: [
        {
            iconId: 'code',
            title: 'Frontend Development',
            description: 'Creating dynamic and responsive user interfaces',
            technologies: ['React', 'Next.js', 'TypeScript', 'Redux', 'Three.js', 'JavaScript'],
        },
        {
            iconId: 'server',
            title: 'Backend Development',
            description: 'Building robust server-side applications and APIs',
            technologies: ['Node.js', 'PHP', 'Laravel', 'Express.js', 'Strapi'],
        },
        {
            iconId: 'globe',
            title: 'CMS Development',
            description: 'Developing custom themes and plugins for content management systems',
            technologies: ['WordPress', 'WooCommerce', 'Craft CMS', 'October CMS'],
        },
        {
            iconId: 'database',
            title: 'Database & Tools',
            description: 'Working with databases, version control and deployment tools',
            technologies: ['MySQL', 'MongoDB', 'Git', 'Docker', 'Postman'],
        },
    ],
    quote: {
        text: '"Transforming ideas into elegant digital realities"',
        subtitle: '— My development philosophy',
    },
};
